import { useState } from "react";
import { RelatoriosLayout } from "../../../layouts";
import {
  FormFiltroAvancado,
  FormFiltroAvancadoComissaoVendedores,
  FormFiltroAvancadoCondicional,
  FormFiltroAvancadoContador,
  FormFiltroAvancadoNfSaida,
  FormFiltroAvancadoVendas,
  FormFiltroAvancadoDesvioPreco,
  FormFiltroAvancadoAnaliseAbcProdutos,
  FormFiltroAvancadoGradeClientes,
} from "./components";
import {
  CondicionaisService,
  NfSaidaService,
  notification,
  OrcamentosService,
  PedidosService,
  SessionService,
} from "../../../services";
import {
  PrintOrcamentoResumido,
  PrintNfSaidaResumido,
  PrintNfSaidaDetalhado,
  PrintPedidoResumido,
  PrintComissaoVendedores,
  PrintNfSaidaResumidoContador,
  PrintCondicionalResumido,
} from "../layouts";
import { responseErros } from "../../../utils";
import { PermisoesHelper, responseStreamHelper } from "../../../helpers";
import FormFiltroAvancadoItensCancelados from "./components/form-filtro-avancado-itens-cancelados.component";
import FormFiltroAvancadoVendasCliente from "./components/form-filtro-avancado-vendas-cliente.component";

const condicionaisService = new CondicionaisService();
const orcamentosService = new OrcamentosService();
const pedidosService = new PedidosService();
const nfSaidaService = new NfSaidaService();
const sessionService = new SessionService();

const RelatoriosFaturamento = () => {
  const permissoesHelper = new PermisoesHelper();
  const [loading, setLoading] = useState(false);
  const [filtrosAplicadosImpressao, setFiltrosAplicadosImpressao] = useState(
    {},
  );
  const [filtrosAvancados, setFiltrosAvancados] = useState({});
  const empresa = sessionService.getEmpresa();

  const subgruposRelatorios = [
    {
      subgrupo: "Condicional",
      propriedades: [
        {
          name: "90 - Condicional Resumido",
          layoutImpressao: PrintCondicionalResumido,
          permissao: permissoesHelper.temPermisao(
            "relatorio-condicional-resumido",
          ),
          funcaoBuscarDadosRelatorio: buscarCondicionalResumido,
          formulario: FormFiltroAvancadoCondicional,
        },
      ],
    },
    {
      subgrupo: "Orçamento",
      propriedades: [
        {
          name: "300 - Orçamento Resumido",
          layoutImpressao: PrintOrcamentoResumido,
          permissao: permissoesHelper.temPermisao(
            "relatorio-orcamento-resumido",
          ),
          funcaoBuscarDadosRelatorio: buscarOrcamentoResumido,
          formulario: FormFiltroAvancado,
        },
      ],
    },
    {
      subgrupo: "Pedido",
      propriedades: [
        {
          name: "400 - Pedido Resumido",
          layoutImpressao: PrintPedidoResumido,
          permissao: permissoesHelper.temPermisao("relatorio-pedido-resumido"),
          funcaoBuscarDadosRelatorio: buscarPedidoResumido,
          formulario: FormFiltroAvancado,
        },
      ],
    },
    {
      subgrupo: "NF Saída",
      propriedades: [
        {
          name: "500 - NF Saída Resumido",
          layoutImpressao: PrintNfSaidaResumido,
          permissao: permissoesHelper.temPermisao(
            "relatorio-nf-saida-resumido",
          ),
          funcaoBuscarDadosRelatorio: buscarNfSaidaResumido,
          formulario: FormFiltroAvancadoNfSaida,
        },
        {
          name: "501 - NF Saída Detalhado",
          layoutImpressao: PrintNfSaidaDetalhado,
          permissao: permissoesHelper.temPermisao(
            "relatorio-nf-saida-detalhado",
          ),
          funcaoBuscarDadosRelatorio: buscarNfSaidaDetalhado,
          formulario: FormFiltroAvancadoNfSaida,
        },
        {
          name: "502 - Comissão de Vendedores",
          layoutImpressao: PrintComissaoVendedores,
          permissao: permissoesHelper.temPermisao(
            "relatorio-comissao-vendedores",
          ),
          funcaoBuscarDadosRelatorio: buscarComissaoVendedores,
          formulario: FormFiltroAvancadoComissaoVendedores,
        },
        {
          name: "503 - NF Saída (Contador)",
          layoutImpressao: PrintNfSaidaResumidoContador,
          permissao: permissoesHelper.temPermisao(
            "relatorio-nf-saida-contador",
          ),
          funcaoBuscarDadosRelatorio: buscarNfSaidaResumidoContador,
          formulario: FormFiltroAvancadoContador,
        },
        {
          name: "504 - Vendas por Vendedor",
          layoutImpressao: PrintNfSaidaResumidoContador,
          permissao: permissoesHelper.temPermisao(
            "relatorio-vendas-por-vendedor",
          ),
          funcaoBuscarDadosRelatorio: buscarVendasPorVendedor,
          formulario: FormFiltroAvancadoVendas,
        },
        {
          name: "505 - Cancelamento de Itens por Operador (PDV)",
          layoutImpressao: PrintNfSaidaResumidoContador,
          permissao: permissoesHelper.temPermisao(
            "relatorio-cancelamento-itens",
          ),
          funcaoBuscarDadosRelatorio: buscarRelatorioItensCancelados,
          formulario: FormFiltroAvancadoItensCancelados,
        },
        {
          name: "506 - Desvio de Preço Praticado",
          layoutImpressao: PrintNfSaidaResumido,
          permissao: permissoesHelper.temPermisao(
            "relatorio-desvio-preco-praticado",
          ),
          funcaoBuscarDadosRelatorio: buscarRelatorioDesvioPreco,
          formulario: FormFiltroAvancadoDesvioPreco,
        },
        {
          name: "507 - Análise ABC Faturamento por Produto",
          layoutImpressao: PrintNfSaidaResumido,
          permissao: permissoesHelper.temPermisao(
            "relatorio-analise-abc-faturamento",
          ),
          funcaoBuscarDadosRelatorio: buscarRelatorioAnaliseAbcProduto,
          formulario: FormFiltroAvancadoAnaliseAbcProdutos,
        },
        {
          name: "508 - Vendas por Cliente",
          layoutImpressao: PrintNfSaidaResumido,
          permissao: permissoesHelper.temPermisao(
            "relatorio-vendas-por-cliente",
          ),
          funcaoBuscarDadosRelatorio: buscarRelatorioVendasCliente,
          formulario: FormFiltroAvancadoVendasCliente,
        },
      ],
    },
    {
      subgrupo: "Cliente",
      propriedades: [
        {
          name: "509 - Grade x Clientes",
          layoutImpressao: PrintNfSaidaResumido,
          permissao: permissoesHelper.temPermisao("relatorio-clientes-grade"),
          funcaoBuscarDadosRelatorio: buscarRelatorioGradeClientes,
          formulario: FormFiltroAvancadoGradeClientes,
        },
      ],
    },
    {
      subgrupo: "Faturamento",
      propriedades: [
        {
          name: "510 - Monitor Faturamento",
          layoutImpressao: PrintNfSaidaResumido,
          permissao: /* permissoesHelper.temPermisao(
            "relatorio-monitor-faturamento",
          ), */ true,
          dashboard: true,
          dashboardUrl: "/monitor-faturamento",
        },
      ],
    },
  ];

  async function buscarCondicionalResumido(filtros) {
    setLoading(true);
    try {
      const result = await condicionaisService.relatorioResumido({
        ...filtros,
        resumido: true,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarOrcamentoResumido(filtros) {
    setLoading(true);
    try {
      const result = await orcamentosService.relatorioResumido({
        ...filtros,
        resumido: true,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarPedidoResumido(filtros) {
    setLoading(true);
    try {
      const result = await pedidosService.relatorioResumido({
        ...filtros,
        resumido: true,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarNfSaidaResumido(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioResumido({
        ...filtros,
        resumido: true,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function openAbaRelatorio(blob) {
    try {
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  async function buscarNfSaidaDetalhado(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioDetalhado(filtros);
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarComissaoVendedores(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioComissaoVendedores({
        ...filtros,
        modalidade: empresa?.configuracoes?.modalidadeComissao || "FATURAMENTO",
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarNfSaidaResumidoContador(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioResumidoContador({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarRelatorioDesvioPreco(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioDesvioPreco({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarVendasPorVendedor(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioVendasVendedor({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarRelatorioItensCancelados(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioItensCancelados({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarRelatorioAnaliseAbcProduto(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioAnaliseAbcProdutos({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarRelatorioVendasCliente(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioVendasCliente({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  async function buscarRelatorioGradeClientes(filtros) {
    setLoading(true);
    try {
      const result = await nfSaidaService.getRelatorioGradeClientes({
        ...filtros,
      });
      if (!result.ok) {
        setLoading(false);
        responseErros(result);
        return {};
      }
      const blob = await responseStreamHelper.getBlobPdf(result);
      setLoading(false);
      await openAbaRelatorio(blob);
    } catch (error) {
      setLoading(false);
      notification.erroInternoServidor();
    }
  }

  return (
    <RelatoriosLayout
      title="Relatórios de Vendas"
      subgruposRelatorios={subgruposRelatorios}
      filtrosAplicadosImpressao={filtrosAplicadosImpressao}
      dadosRelatorioResumido={{}}
      setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
      filtrosAvancados={filtrosAvancados}
      setFiltrosAvancados={setFiltrosAvancados}
      loading={loading}
    />
  );
};

export default RelatoriosFaturamento;
